<template>
  <section>
    <gs-header title="Thêm mới dịch vụ"
      :breadcrumbs="[
        {title: 'Quản lý dịch vụ', route: {name: 'services'}}
      ]"
    >
    </gs-header>
    <div class="padding-sm-all">
      <el-form label-position="top" class="margin-top" :rules="rules" ref="create-service-form" :model="localService" label-width="150px" @submit.prevent.native="validatorBeforeSubmit">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Tên" prop="name">
              <el-input v-model="localService.name" placeholder="Tên"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Tên viết tắt" prop="short_name">
              <el-input v-model="localService.short_name" placeholder="Tên viết tắt"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Danh mục cha" prop="parent_id">
              <el-select v-model="localService.parent_id" filterable placeholder="Chọn danh mục cha" :class="['width-100']">
                <el-option
                  v-for="(service, index) in services"
                  :key="index"
                  :label="service.name"
                  :value="service.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Icon" prop="icon">
              <el-input v-model="localService.icon" placeholder="fa fa-font-awesome"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Độ ưu tiên" prop="priority">
              <el-input v-model="localService.priority" placeholder="Độ ưu tiên"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Mô tả" prop="description">
              <el-input type="textarea" v-model="localService.description" placeholder="Mô tả"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <button :disabled="submitting" class="ui blue basic small button" native-type="submit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
      </el-form>
    </div>
  </section>
</template>

<script>
  import { head } from 'lodash'
  import { addService } from 'src/api/service'
  import serviceMixins from './mixins'
  export default {
    name: 'NewService',
    mixins: [serviceMixins],
    methods: {
      validatorBeforeSubmit () {
        this.submitting = true
        this.$refs['create-service-form'].validate((valid) => {
          if (valid) {
            this.changedData = false
            addService(this.localService).then(response => {
              switch (response.code) {
                case 200:
                  this.submitting = false
                  this.$store.dispatch('showNotify', {
                    title: 'Thêm mới thành công',
                    body: 'Tạo mới dịch vụ thành công',
                    type: 'success'
                  })
                  this.reloadGsTableAfterRedirect({name: 'services'}, 'services')
                  this.toggleLoadding(false)
                  break
                case 422:
                  this.submitting = false
                  let er = response.data.errors
                  let message = head(er[Object.keys(er)[0]])
                  this.$store.dispatch('showNotify', {
                    title: 'Vui lòng kiểm tra thông tin cần nhập',
                    body: message,
                    type: 'warning'
                  })
                  this.toggleLoadding(false)
                  break
                default:
                  this.submitting = false
                  this.$store.dispatch('showNotify', {
                    title: 'Thêm mới thất bại',
                    body: 'Tạo dịch vụ thất bại vui lòng kiểm tra lại thông tin',
                    type: 'danger'
                  })
                  this.toggleLoadding(false)
              }
            })
          } else {
            this.submitting = false
            this.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin cần nhập',
              type: 'warning'
            })
            return false
          }
        })
      },
      newService () {
        this.localService = {
          name: '',
          short_name: '',
          parent_id: undefined,
          icon: null,
          description: '',
          priority: 0
        }
        setTimeout(() => {
          this.watching = true
        }, 100)
      }
    }
  }
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// NewService.vue?115e891f